import * as angular from 'angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import './app.module.ajs';
import { NgAppModule } from './app.module';

// Wait for the DOM to be ready
angular.element(() => {
    // Manually bootstrap AngularJS
    angular.bootstrap(document.body, ['veriApp'], { strictDi: true });

    // Then bootstrap Angular
    platformBrowserDynamic()
        .bootstrapModule(NgAppModule)
        .catch(err => console.error(err));
});
